import { createFileRoute, redirect } from '@tanstack/react-router';

import { ClassCountTuitionSettings } from '~pages/payments/class-count-tuition/index';
import { UserRoles } from '~entities/users/model/types';
import { checkMinRoleValue } from '~shared/utils/role-guard';

const PendingComponent = () => {
  return (
    <div className='flex h-screen items-center justify-center'>Loading....</div>
  );
};

export const Route = createFileRoute(
  '/_auth/_layout/payment/class-count-tuition/',
)({
  beforeLoad: async () => {
    const hasAccess = await checkMinRoleValue(UserRoles.SUPER_ADMIN);
    if (!hasAccess) {
      return redirect({
        to: '/dashboard',
      });
    }
  },
  pendingComponent: PendingComponent,
  component: ClassCountTuitionSettings,
});
